import { Manager } from './core/Manager';
import { BaseGameScene } from "./scene/BaseGameScene"; // Adjust path if needed
//import { PerformanceProfiler } from "./PerformanceProfiler";

// ==========================================
// PHASE 0: PROFILER HOOKS
// ==========================================

// 1. Instrument Spine creation
// const originalSpineFrom = Spine.from;
// if (!Spine.__PROFILER_FROM_PATCHED__) {
//     Spine.__PROFILER_FROM_PATCHED__ = true;
//     Spine.from = function (...args) {
//         //PerformanceProfiler.increment('spineCreated');
//         return originalSpineFrom.apply(this, args);
//     };
// }

// // 2. Instrument Spine destruction
// const originalSpineDestroy = Spine.prototype.destroy;
// if (!Spine.prototype.__PROFILER_DESTROY_PATCHED__) {
//     Spine.prototype.__PROFILER_DESTROY_PATCHED__ = true;
//     Spine.prototype.destroy = function (options) {
//         //PerformanceProfiler.increment('spineDestroyed');
//         originalSpineDestroy.call(this, options);
//     };
// }

// // 3. Instrument Asset loading/unloading
// if (!Assets.__PROFILER_PATCHED__) {
//     Assets.__PROFILER_PATCHED__ = true;

//     const originalLoadBundle = Assets.loadBundle;
//     Assets.loadBundle = async function (...args) {
//         //PerformanceProfiler.increment('bundleLoaded');
//         console.log(`[ASSET INSTRUMENTATION] Loading bundle(s):`, args[0]);
//         return originalLoadBundle.apply(this, args);
//     };

//     const originalUnload = Assets.unload;
//     Assets.unload = async function (...args) {
//         //PerformanceProfiler.increment('bundleUnloaded');
//         console.log(`[ASSET INSTRUMENTATION] Unloading bundle(s):`, args[0]);
//         return originalUnload.apply(this, args);
//     };
// }
// ==========================================

(async () => {
    await Manager.initialize("#000000");

    console.log("after initialize");
    //new GameScene(); 
    const game = new BaseGameScene();
    await Manager.changeScene(game, true);

})();